import {_post,_get} from "./Axios";
import LocalRepository from "../LocalRepository";

export default class AuthApi {
    static login(data) {
        return _post('akun/auth/login', data)
    }

    static check_token_koas(data) {
        return _get('akun/auth/check_token_koas/'+data)
    }

    static check_token(data) {
        const firebase_token = LocalRepository.getFirebaseToken() ?? ""

        return _get('akun/auth/check_token/' + data + '/' + firebase_token)
    }
}